import type { BotLaunchStatus } from '../../types/leadBot.js';
import { LAUNCH_LABELS, canTransition, type LaunchActor } from '../leadBot/launch.js';
import type { ReviewItems } from '../../types/kyckConnect.js';

// LAUNCH CONTROLS: the pure view logic. PURE. The server decides every move (canTransition, the go-live gate, admin-only reply mode);
// this only decides which buttons to OFFER, so a person is not shown a move the server will refuse on the first rule.

const ORDER: BotLaunchStatus[] = ['setting_up', 'testing', 'live', 'on_hold'];

export function movesFor(from: BotLaunchStatus, actor: LaunchActor): BotLaunchStatus[] {
  return ORDER.filter((to) => canTransition(from, to, actor));
}

export function moveLabel(to: BotLaunchStatus): string {
  switch (to) {
    case 'setting_up':
      return 'Back to setting up';
    case 'testing':
      return 'Start testing';
    case 'live':
      return 'Go live';
    case 'on_hold':
      return 'Pause';
  }
}

/** The confirm sentence an admin sees before a move that changes who is texted. */
export function confirmText(to: BotLaunchStatus): string {
  return to === 'live'
    ? `Take this club ${LAUNCH_LABELS.live.toLowerCase()}? Real leads will be texted, or get drafts a person approves, depending on the reply setting.`
    : `Move this club to ${LAUNCH_LABELS[to]}?`;
}

export function reviewCount(r: ReviewItems): number {
  return r.sections.length + r.promotions.length + (r.followUps ? 1 : 0);
}
